module.exports = __webpack_public_path__ + "20250721160708/img/logo.c43bef0f.png";